<template>
<div class="section-sales-channels" id="beneficios">
	<v-flex class="w-semibold primary--text title-chanell-mobile br-mobile" text-xs-center> <span class="secondary--text">¡No pierdas Ventas!</span> Conoce los Beneficios de Tu Tienda Online Gratis</v-flex>
	<v-flex text-xs-center class="br-desktop title-section-sales secondary--text w-bold">¡Con CasaMarket no pierdas Ventas! <span class="primary--text"> Ten tus productos integrados en todos los canales de venta </span></v-flex>
		<div class="grid-channels">
			<v-layout column class="card-channel" v-for="(card, index) in channels" :key="index">
				<v-flex text-xs-center xs1>
					<img :src="card.image" alt="" class="img-card-channel">
				</v-flex>
				<v-flex class="newwarning--text text-card-channel" xs10>
					{{ card.name }}
				</v-flex>
			</v-layout>
	</div>
	<v-flex class="newwarning--text w-bold mt-5 text-discount" text-xs-center>
		Conoce Nuestros Planes <br> Tenemos <span class="primary--text w-black">50% de descuento por lanzamiento</span>
	</v-flex>
	<v-flex text-xs-center class="mt-3">
		<a class="href-depressed w-semibold" :href="linkPlan" target="_blank">
			<v-btn
				class="btn-plans ma-0 w-black"
				color="orange"
				depressed
			>
				VER PLANES
			</v-btn>
		</a>
	</v-flex>
</div>
</template>

<script>
function linkPlan() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	const regDeviceOne = /Android|webOS|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	const regDeviceTwo = /iPad|iPhone|iPod/;
	if (regDeviceOne.test(userAgent)) {
		return 'https://plans-pdf.s3.amazonaws.com/PLANES-MOBILE.pdf';
	} else if (regDeviceTwo.test(userAgent) && !window.MSStream) {
		return 'https://plans-pdf.s3.amazonaws.com/PLANES-MOBILE.pdf';
	}
	return 'https://plans-pdf.s3.amazonaws.com/PLANES.pdf';
}

function data() {
	return {
		channels: [
			{
				id: 1,
				name: 'Tienda Online',
				image: '/static/images-new/icons/channel-1.svg',
			},
			{
				id: 2,
				name: 'Vende Productos o Servicios',
				image: '/static/images-new/icons/channel-2.svg',
			},
			{
				id: 3,
				name: 'Vende por WhatsApp',
				image: '/static/images-new/icons/channel-3.svg',
			},
			{
				id: 4,
				name: 'Web Responsive',
				image: '/static/images-new/icons/channel-2.svg',
			},
			{
				id: 5,
				name: 'Opción de Delivery o recojo en tienda',
				image: '/static/images-new/icons/channel-5.svg',
			},
			{
				id: 6,
				name: 'App para Gestionar tu Tienda Online',
				image: '/static/images-new/icons/channel-6.svg',
			},
			{
				id: 7,
				name: 'Múltiples Medios de Pago',
				image: '/static/images-new/icons/channel-8.svg',
			},
			{
				id: 8,
				name: 'Catálogo de productos con imágenes',
				image: '/static/images-new/icons/channel-9.svg',
			},
		],
	};
}

export default {
	name: 'section-sales-channels',
	data,
	computed: {
		linkPlan,
	},
};
</script>

<style lang="scss" scoped>
.section-sales-channels {
	background-color: color(white);
	padding: 50px 12px 42px 12px;
	position: relative;

	@media (min-width: 936px) {
		padding: 70px 0 75px 0;
	}

	// &::before {
	// 	content: '';
    // width: 0;
    // height: 0;
    // border-style: solid;
    // border-width: 1411px 0 0 200px;
    // border-color: transparent transparent transparent color(information);
    // position: absolute;
    // top: -617px;
    // left: 533px;
    // transform: rotate(91deg);
	// }

	// @media (max-width: 1411px) {
	// 	&::before {
	// 		content: none;
	// 	}
	// }
}

.title-section-sales {
	font-size: 28px;
	margin: 0 auto;
	max-width: 750px;
	position: relative;
}

.card-channel {
	background-color: map-get($colors, white);
	border-radius: 9px;
  	box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.06);
	max-width: 184px;
	padding: 23px 16px;

	@media (max-width: 936px) {
		align-items: center;
		background-color: white;
		border-radius: 9px;
		border: solid 1px #acdada;
		display: flex;
		flex-direction: row;
		padding: 13px 18px 10px 10px;
	}
}

.grid-channels {
	display: grid;
	grid-gap: 6px;
	grid-template-columns: auto auto;
	justify-content: center;
	margin-top: 25px;

	@media (min-width: 936px) {
		grid-gap: 30px 21px;
		grid-template-columns: auto auto auto auto;
		grid-gap: 30px 21px;
		margin-top: 45px;
	}
}

.text-discount {
	font-size: map-get($sizes, medium18);
	margin: 0 auto;
	max-width: 382px;

	@media (min-width: 936px) {
		font-size: map-get($sizes, medium19);
	}
}

.text-card-channel {
	font-size: 10px;
	margin: 0 0 0 10px;
	text-align: left;

	@media (min-width: 936px) {
		margin-top: 24px;
		font-size: 14px;
		text-align: center;
	}
}

.img-card-channel {
	height: 24px;

	@media (min-width: 936px) {
		height: 42px;
	}
}

.title-chanell-mobile {
	font-size: 18px;
	margin: 0 auto;
	max-width: 235px;
}

.btn-plans {
	border-radius: 35.5px;
	color: color(white);
	font-size: size(medium16);
	height: 61px;
	width: 171px !important;

	@media (min-width: 936px) {
		font-size: size(medium18);
		width: 191px !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home-new/section-sales-channels.vue